import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.loadModels(1);
  }

  loadModels(page = 1) {
    const modelsContainer = document.querySelector(`#models-container`);
    const cardBody = modelsContainer.querySelector('.card-body');
    const makeId = modelsContainer.dataset.makeId;

    cardBody.innerHTML += '<div class="text-center loading-indicator"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div></div>';

    fetch(`/make_models/${makeId}/fetch_models?page=${page}`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {
      cardBody.querySelector('.loading-indicator').remove();
      if (!cardBody.querySelector('#models-table')) { 
        let tableHtml = '<table id="models-table" class="table table-sm table-hover mb-0"><thead><tr><th>Model</th><th width="150">Actions</th></tr></thead><tbody></tbody></table>'
        cardBody.innerHTML = tableHtml
      }
      // Render models table
      if (data.models.length > 0) {
        let modelTableRows = "";
        data.models.forEach(model => {
          modelTableRows += this.setupModelTableRow(model, makeId);
        })
        cardBody.querySelector('tbody').innerHTML += modelTableRows;
        this.setupInfiniteScroll(makeId, data.next_page);
      } else {
        if (page == 1) { 
          cardBody.innerHTML = '<div class="alert alert-info mb-0">No models found for this make.</div>'
        }
      }
    })
    .catch(error => {
      console.error('Error loading models:', error);
      cardBody.innerHTML = '<div class="alert alert-danger mb-0">Error loading models. Please try again.</div>'
    });
  }

  setupModelTableRow(model, makeId) {
    return `
            <tr class="model-row" data-model="${model.name.toLowerCase()}"style="cursor: pointer;">
              <td onclick="window.location.href='/vehicle_models/${model.id}'">${this.escapeHtml(model.name)}</td>
              <td>
                <a href="/vehicle_models/${model.id}/edit?vehicle_make_id=${makeId}" class="btn btn-xs btn-outline-primary me-1">Edit</a>
                <a href="/vehicle_models/${model.id}?vehicle_make_id=${makeId}" class="btn btn-xs btn-outline-danger" data-method="delete" data-confirm="Are you sure you want to delete this vehicle model?">Delete</a>
              </td>
            </tr>
          `
  }

  setupInfiniteScroll(makeId, nextPage) {
    // Clean up existing observer if any
    this.cleanupObserver(makeId);

    if (!nextPage) return;

    const modelsContainer = document.querySelector(`#models-container`);
    const cardBody = modelsContainer.querySelector('.card-body');
    const tbody = cardBody.querySelector('tbody');
    
    if (!tbody || !modelsContainer) return;

    // Create a sentinel element at the bottom to detect when scrolled into view
    const sentinel = document.createElement('tr');
    sentinel.id = `sentinel-${makeId}`;
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.innerHTML = '<td colspan="2" style="height: 1px;"></td>';
    tbody.appendChild(sentinel);

    // Use Intersection Observer for better performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadModels(nextPage);
        }
      });
    }, {
      root: null,
      rootMargin: '100px', // Start loading 100px before reaching the bottom
      threshold: 0.1
    });

    observer.observe(sentinel);
  }

  cleanupObserver(makeId) {
    let sentinel = document.getElementById(`sentinel-${makeId}`);
    if (sentinel) {
      sentinel.remove();
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}